import app from 'app'; // eslint-disable-line
import { getPaCartProperties } from 'utils/pa-cart-properties';

/**
 * Fetch cart
 * @returns {object} cart
 */
const fetchCart = () => fetch('/cart?view=data', {
  method: 'GET',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
}).then((response) => response.json());

/**
 * Add item to cart based on variant ID
 * @param {int} variantId
 * @param {int} quantity
 * @param {object} properties
 * @param {function} callback
 */
const addVariant = ({
  variantId,
  quantity,
  properties = {},
  callback,
}) => new Promise((resolve) => {
  app.emit('cart:disable');

  const formData = {
    id: variantId,
    quantity,
    properties: {
      ...getPaCartProperties(),
      ...properties,
    },
    sections: 'cart-drawer,cart-button',
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then(async (data) => {
      const cart = await fetchCart();

      app.emit('cart:updated', {
        cart,
        cartDrawerMarkup: data.sections['cart-drawer'],
      });

      if (callback) {
        callback();
      }

      resolve(app.emit('cart:enable'));
    });
});

/**
 * Change cart item
 * @param {string} key - can either be line item key or variant ID
 * @param {int} quantity
 * @param {function} callback
 */
const changeItem = ({
  key,
  quantity,
  callback,
}) => new Promise((resolve) => {
  app.emit('cart:disable');

  const formData = {
    id: key,
    quantity,
    sections: 'cart-drawer',
  };

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then(async (data) => {
      const cart = await fetchCart();

      app.emit('cart:updated', {
        cart,
        cartDrawerMarkup: data.sections['cart-drawer'],
      });

      if (callback) {
        callback();
      }

      resolve(app.emit('cart:enable'));
    });
});

export { fetchCart, addVariant, changeItem };
